import React from 'react';
import ActionButton from '../action-button';
import IconButton from '../icon-button';
import { MODES } from './constants';
import { PublishButton } from './components';
import { useMatchLGBreakpoint } from '../../hooks';
const PreviewModeHeader = ({ captions, onBack, onPublish, onToggleMode, selectedMode }) => {
  const isLargeScreen = useMatchLGBreakpoint();

  const handleToggleMode = (mode) => () => onToggleMode(mode);

  return (
    <div className="ws-ui-preview-mode-header">
      <div className="ws-ui-preview-mode-header__left">
        <ActionButton
          size="small"
          format={isLargeScreen ? 'text' : 'solid-white'}
          iconPlacement="before"
          iconGlyph="back"
          onClick={onBack}
          // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'null'.
          label={isLargeScreen ? captions.back : null}
        />
      </div>
      <div className="ws-ui-preview-mode-header__center">
        <IconButton
          glyph="monitor"
          onClick={handleToggleMode(MODES.desktop)}
          selected={selectedMode === MODES.desktop}
        />
        <IconButton
          glyph="tablet"
          onClick={handleToggleMode(MODES.tablet)}
          selected={selectedMode === MODES.tablet}
        />
        <IconButton
          glyph="smartphone"
          onClick={handleToggleMode(MODES.mobile)}
          selected={selectedMode === MODES.mobile}
        />
      </div>
      <div className="ws-ui-preview-mode-header__right">
        <PublishButton onClick={onPublish} label={captions.publish} isCompact={!isLargeScreen} />
      </div>
    </div>
  );
};

export default PreviewModeHeader;
